module.exports = __webpack_public_path__ + "static/media/load.5fe0e55f.gif";